import React, { Component } from 'react'
import './LoadingBlock.scss'

import Loading from './Loading'

class LoadingBlock extends Component {
    state = {
        x: "150"
    }
    render() {
        if (!this.props.open) return null
        else return (
            <div className="overlay">
                <Loading componentName={this.props.children} fixEllipsisStyle></Loading>
            </div>
        )
    }
}

export default LoadingBlock